// Белый список контракта MOB-418. Сервер уже чистит HtmlPurifier'ом — это защитный слой.
const ALLOWED = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI'])
// Содержимое этих тегов не текст — выбрасываем целиком, а не разворачиваем.
const DROPPED = new Set(['SCRIPT', 'STYLE', 'TEMPLATE', 'IFRAME', 'OBJECT', 'NOSCRIPT'])
const TEXT_ALIGN = /^\s*text-align\s*:\s*(left|center|right|justify)\s*;?\s*$/i

function copyChildren (from: Node, to: Node): void {
  from.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      to.appendChild(document.createTextNode(node.textContent ?? ''))
      return
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return

    const el = node as Element
    if (DROPPED.has(el.tagName)) return
    if (!ALLOWED.has(el.tagName)) {
      copyChildren(el, to)
      return
    }

    const clean = document.createElement(el.tagName.toLowerCase())
    const style = el.getAttribute('style')
    if (el.tagName === 'P' && style && TEXT_ALIGN.test(style)) {
      clean.setAttribute('style', style.trim())
    }
    copyChildren(el, clean)
    to.appendChild(clean)
  })
}

export function sanitizeHtml (html: string): string {
  const parsed = new window.DOMParser().parseFromString(html, 'text/html')
  const out = document.createElement('div')
  copyChildren(parsed.body, out)
  return out.innerHTML
}
